import React from "react";
import { VestingSummaryReportsContainer } from "../../../containers";

const VestingSummaryReports = (props) => {
  return (
    <VestingSummaryReportsContainer
      menu="eligibility"
      subMenu="vestingSummaryReports"
      {...props}
    />
  );
};

export default VestingSummaryReports;
